export interface AdditionalSymbolInfo {
  description: string;
  digits: number | undefined;
  currencySource: string;
  volumePrecision: number | undefined;
  symbolGroup: string;
  popularity: number | undefined;
  volumeMin: number | undefined;
  volumeStep: number | undefined;
  symbolView: string;
  currencyBase: string;
  currencyProfit: string;
  symbol: string;
  volumeMax: number | undefined;
  contractSize: number | undefined;
  tradeMode: number | undefined;
}

export type AdditionalSymbolInfoKey = keyof AdditionalSymbolInfo;

export const SYMBOL_INFO_URL_PARAMS = {
  symbol: 'symbol',
  symbolGroup: 'symbol-group',
  description: 'symbolDescription',
  digits: 'symbolDigits',
  currencySource: 'currencySource',
  volumePrecision: 'volumePrecision',
  popularity: 'symbolPopularity',
  volumeMin: 'volumeMin',
  volumeStep: 'volumeStep',
  symbolView: 'symbolView',
  currencyBase: 'currencyBase',
  currencyProfit: 'currencyProfit',
  volumeMax: 'volumeMax',
  contractSize: 'contractSize',
  tradeMode: 'tradeMode',
} as const satisfies Record<AdditionalSymbolInfoKey, string>;

export type SymbolInfoUrlParam = (typeof SYMBOL_INFO_URL_PARAMS)[keyof typeof SYMBOL_INFO_URL_PARAMS];
